// @flow

import type { Action } from "./actions"
import type { StoredPassengers, StoredPassenger } from "booking/services/storedPassengers/types"

export default function storedPassengersReducer(state: StoredPassengers = [], action: Action) {
  switch (action.type) {
    case "INIT_STORED_PASSENGERS":
      return action.payload.map<StoredPassenger>(x => ({
        ...x,
        origin: "local",
      }))

    case "MERGE_STORED_PASSENGERS":
      return [...state, ...action.payload.map(x => ({ ...x, origin: "server" }))]

    case "REMOVE_STORED_PASSENGER":
      // $FlowFixMe
      return state.filter(x => x !== action.payload)

    default:
      return state
  }
}

export const storedPassengersSelector = (state: any) => state.reservation.storedPassengers
